<div class="super-button-icon-wrapper" sxCenterize="row" (click)="execute()">
  <ion-icon name="{{icon}}" [color]="color" *ngIf="!isLoading"></ion-icon>
  <ion-spinner *ngIf="isLoading"></ion-spinner>
</div>

